import { CommunicationDtoType } from "./type";
import ConsoleApi from "../../enums/consoleApi";
import { useGetApiData } from "shared/datalayer";

export function useGetCommunicationDTOMap() {
  return useGetApiData<CommunicationDtoType>(ConsoleApi.STATIC_DATA_COMMUNICATION_FIELDS);
}
